export default __webpack_public_path__ + "static/media/Bracers of Pandemonium.f91a2346.jpg";